export function getStringByContext(forceCase) {
    const string = String(this || '');
    const endWithinS = string.endsWith('s');
    let labelReplaced = string;
    if (forceCase) {
        labelReplaced = labelReplaced[forceCase]();
    }
    return {
        singular() {
            if (!endWithinS)
                return labelReplaced;
            if (labelReplaced.includes('ões')) {
                return labelReplaced.replace('ões', 'ão');
            }
            return labelReplaced.slice(0, -1);
        },
        plural() {
            if (endWithinS)
                return labelReplaced;
            if (labelReplaced.includes('ão')) {
                return labelReplaced.replace('ão', 'ões');
            }
            return `${labelReplaced}${forceCase === 'toLowerCase' ? 's' : 'S'}`;
        },
    };
}
//# sourceMappingURL=getStringByContext.js.map